import { ActionType, ControlType } from "../types";

import { IActionEntry } from "./IActionEntry";
import { IControlEntry } from "./IControlEntry";

export class ComponentRegistry {
    private static instance: ComponentRegistry;
    private _controls: IControlEntry[];
    private _actions: IActionEntry[];

    private constructor() {
        this._controls = [];
        this._actions = [];
    }

    public static getInstance(): ComponentRegistry {
        if (!ComponentRegistry.instance)
            ComponentRegistry.instance = new ComponentRegistry();

        return ComponentRegistry.instance;
    }

    public get controls(): ReadonlyArray<IControlEntry> {
        return this._controls;
    }

    public get actions(): ReadonlyArray<IActionEntry> {
        return this._actions;
    }

    public getControlByType(type: ControlType) {
        return this._controls.find(p => p.type === type);
    }

    public getActionByType(type: ActionType) {
        return this._actions.find(p => p.type === type);
    }

    public addControl(component: IControlEntry): void {
        const index = this._controls.findIndex(p => p.id === component.id);
        if (index !== -1) {
            this._controls[index] = component;
        } else {
            this._controls.push(component);
        }
    }

    public addAction(action: IActionEntry): void {
        const index = this._actions.findIndex(p => p.id === action.id);
        if (index !== -1) {
            this._actions[index] = action;
        } else {
            this._actions.push(action);
        }
    }
}

export const Registry = ComponentRegistry.getInstance();
